import React, {Component} from 'react';

import '../sass/faq.scss';

import HeaderFaq from '../components/faq/HeaderFaq';
import Footer from '../components/Footer';
import QuestionsSite from '../components/faq/QuestionsSite';
import faqEntries from 'components/faq/Entries';

class Faq extends Component {
    render() {
        return (
            <div id="wrapper" className="faq-wrapper">
                <HeaderFaq />
                <QuestionsSite faq={faqEntries.website} name="Questions générales concernant le site" bg={true} />
                <QuestionsSite faq={faqEntries.room} name="Questions concernant les salles de tchat" bg={false} />
                <Footer />
            </div>
        )
    }
}

export default Faq;


// WEBPACK FOOTER //
// ./src/containers/Faq.js